<script>
	import { fileContentChecker, isVideoFile } from "src/utils/misc";
	import VideoThumbnail from "../VideoPlayer/VideoThumbnail.svelte";

	export let thumbImg;
	export let altTag;
	export let id;
	export let selected;
</script>

<div class="thumbnail-cont" class:active={selected}>
	{#if isVideoFile(thumbImg)}
		<VideoThumbnail on:click />
	{:else}
		<img
			class="sample cursor"
			{id}
			src={fileContentChecker(thumbImg)}
			alt={altTag}
			on:click
			on:keydown={() => {}}
		/>
	{/if}
</div>

<style>
	/* Six columns side by side */
	.thumbnail-cont {
		width: 8%;
		max-height: 100px;
		display: flex;
		justify-content: center;
		align-items: center;
		background-color: #ddd;
		margin: 22px 6px;
		border-radius: 4px;
		height: 62px;
	}

	/* Add a transparency effect for thumnbail images */
	.sample {
		opacity: 0.8;
	}

	.sample:hover {
		opacity: 1;
	}

	img {
		width: 100%;
		height: 100%;
		transition: all 0.1s ease-in-out;
		border-radius: 4px;
	}

	/* Add a pointer when hovering over the thumbnail images */
	.cursor {
		cursor: pointer;
	}

	.active {
		opacity: 1;
		border: 3px solid #d60c0c;
		box-sizing: border-box;
	}
</style>
